import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Tabs, Tab } from "react-bootstrap";
import { NotificationManager } from "react-notifications";

import FilterPanel from "../../../../sharedComponents/filterPanel";
import PlaceholderImage from "../../../../sharedComponents/placeholderImage";
import { addRecipeImages, removeRecipeImages } from "../../../../store/actions";
import ImagesDropZone from "./imagesDropZone";
import ImagesGallery from "./imagesGallery";
import ConfirmDelete from "../../../../sharedComponents/confirmDelete";

const Images = ({
	refetchRecipe,
	recipeDetails,
	setActiveTab,
	imageList,
	addRecipeImages,
	removeRecipeImages,
	saveAndPublish,
	newAdditions
}) => {
	const [submitting, setSubmitting] = useState(false);
	const [recipeImages, updateRecipeImages] = useState([]);
	useEffect(() => {
		recipeDetails.images && updateRecipeImages(recipeDetails.images);
	}, [recipeDetails]);

	const [atBottom, setAtBottom] = useState(false);
	const [activeImagesTab, setActiveImagesTab] = useState(1);

	const [showAddImagePanel, toggleAddImagePanel] = useState(true);

	useEffect(() => {
		newAdditions("images", recipeImages.filter((item) => item.isNew).length > 0);
	}, [recipeImages, newAdditions]);

	const addImages = () => {
		const newImages = recipeImages.filter((item) => !item.id);
		const listItems = newImages.map((item) => ({
			recipe: recipeDetails.id,
			seq: item.seq ? item.seq : 1,
			source: item.source,
			image: item.image_data.id
		}));
		setSubmitting(true);
		if (listItems.length) {
			const successHandler = (event) => {
				refetchRecipe();
				if (event.status === 201) {
					NotificationManager.success("Successfully added!", "", 5000);
					saveAndPublish(false);
				} else {
					NotificationManager.error("Please try again!", "", 5000);
				}
				setSubmitting(false);
			};
			addRecipeImages(listItems, successHandler);
		} else {
			saveAndPublish();
			setSubmitting(false);
		}
	};

	const removeImage = (imageItem) => {
		const successHandler = updateRecipeImages(recipeImages.filter((item) => item.image !== imageItem.image));
		if (!imageItem.isNew) {
			removeRecipeImages(imageItem.id, successHandler);
		} else {
			updateRecipeImages(recipeImages.filter((item) => item.image !== imageItem.image));
		}
	};

	const handleAddedImage = (image, seq) => {
		updateRecipeImages([
			...recipeImages,
			{
				id: null,
				image: image.id,
				image_data: image,
				recipe: recipeDetails.id,
				seq,
				isNew: true
			}
		]);
	};

	const [deleteItem, setDeleteItem] = useState(null);
	const confirmDelete = (item) => {
		setDeleteItem(item);
	};
	const confirmEvent = (yes) => {
		yes && removeImage(deleteItem);
		setDeleteItem(null);
	};

	return recipeDetails && recipeDetails.id ? (
		<React.Fragment>
			{!recipeImages.length ? (
				<div className="alert-info text-center p-3 mt-4">Please Add an Image to Publish Recipe</div>
			) : null}
			<div className="p-4">
				<div className="row card-wrap">
					<div className="col-2 mb-4" onClick={() => toggleAddImagePanel(true)}>
						<div className="add-image-card">
							<i className="icon icon-plus lg-icon" />
							<div className="mt-2">Add an image</div>
						</div>
					</div>
					{recipeImages.map((item, index) => {
						return (
							<div key={index} className="col-2 mb-4">
								<div className="card card-default h-100">
									<div className="card-nav">
										<button
											className="btn btn-danger btn-cell btn-sm"
											type="button"
											onClick={() => confirmDelete(item)}>
											<i className="icon icon-trash" />
										</button>
									</div>
									<PlaceholderImage
										className="card-image"
										src={item.image_data.photo_m}
										objectFit="cover"
										width="200"
										height="150"
									/>
									<div className="card-title">{item.image_data.name}</div>
								</div>
							</div>
						);
					})}
				</div>
				<div className="tab-footer row pt-3">
					<div className="col-12 text-right">
						<button type="button" className="btn btn-default" onClick={() => setActiveTab(3)}>
							Back
						</button>
						<button
							type="button"
							className="btn btn-primary-dark"
							onClick={addImages}
							disabled={!recipeImages.length || submitting}>
							Save &amp; Publish
						</button>
					</div>
				</div>
			</div>
			<ConfirmDelete item={deleteItem} message={<div>Are you sure you want to delete?</div>} onEvent={confirmEvent} />
			<FilterPanel
				show={showAddImagePanel}
				toggle={() => toggleAddImagePanel(!showAddImagePanel)}
				toggleAtBottom={(event) => activeImagesTab === "2" && setAtBottom(event)}
				closeBtn>
				<div className="panel-tab-wrap">
					<Tabs activeKey={activeImagesTab} onSelect={(event) => setActiveImagesTab(event)}>
						<Tab eventKey={1} title="Upload Image">
							<ImagesDropZone toggleAddImagePanel={toggleAddImagePanel} addedImage={handleAddedImage} />
						</Tab>
						<Tab eventKey={2} title="Image Gallery">
							<ImagesGallery
								imageList={imageList}
								recipeImages={recipeImages}
								atBottom={atBottom}
								setAtBottom={setAtBottom}
								addToRecipeImages={(list) => updateRecipeImages((prevState) => [...prevState, ...list])}
								toggleAddImagePanel={toggleAddImagePanel}
							/>
						</Tab>
					</Tabs>
				</div>
			</FilterPanel>
		</React.Fragment>
	) : null;
};

const mapStateToProps = (state) => {
	return {
		recipeDetails: get(state.Recipes, "recipeDetails", [])
	};
};

const mapDispatchToProps = {
	addRecipeImages,
	removeRecipeImages
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Images);
